import {filter, reduce} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import FollowButton from 'shared/components/follow-button';
import Text from 'shared/components/text';
import {getMedia, watchMedia} from 'shared/mq';
import AwardAmount from './award-amount';
import AwardsList from './awards-list';
import Logo from './logo';

class CollegeCard extends React.Component {
  static propTypes = {
    followCollege: PropTypes.func.isRequired,
    unfollowCollege: PropTypes.func.isRequired,
    slug: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    microScholarships: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        minAmount: PropTypes.number.isRequired,
        maxAmount: PropTypes.number.isRequired,
      })
    ),
    following: PropTypes.bool.isRequired,
    potentialPortfolioItems: PropTypes.arrayOf(
      PropTypes.shape({
        emoji: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        scholarshipType: PropTypes.string.isRequired,
      })
    ).isRequired,
  };

  componentDidMount() {
    this.mq = watchMedia(() => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    this.mq.remove();
  }

  achievementItemsForMicroScholarships(microScholarships, achievementItems) {
    const microScholarshipsSet = reduce(
      microScholarships,
      (accumulator, microScholarship) => {
        accumulator[microScholarship.type] = true;
        return accumulator;
      },
      {}
    );

    return filter(
      achievementItems,
      (achievementItem) => !!microScholarshipsSet[achievementItem.scholarshipType]
    );
  }

  handleFollowClick = (e) => {
    const {following, id} = this.props;

    e.preventDefault();

    if (following) {
      this.props.unfollowCollege(id);
    } else {
      this.props.followCollege(id);
    }
  };

  render() {
    const mq = getMedia();

    const {slug, city, state, name, microScholarships, following, potentialPortfolioItems} =
      this.props;

    const achievementItems = this.achievementItemsForMicroScholarships(
      microScholarships,
      potentialPortfolioItems
    );

    const awardsList = (
      <AwardsList achievementItems={achievementItems} numberEmojisToShow={mq.MS_AND_DOWN ? 4 : 6} />
    );

    return (
      <div className={`college-discovery-step-college-card ${following ? 'active' : ''}`}>
        <Logo slug={slug} name={name} />
        <div className="college-discovery-step-college-card-details">
          <Text emphasis>{name}</Text>
          <Text weight={6} className="college-discovery-step-college-card-details-location">
            {city}, {state}
          </Text>
          {!mq.MS_AND_DOWN && awardsList}
        </div>
        {mq.MS_AND_DOWN && awardsList}
        <div className="college-discovery-step-college-card-amount-section">
          <AwardAmount
            following={following}
            microScholarships={microScholarships}
            achievementItems={achievementItems}
          />
        </div>
        <div className="college-discovery-step-college-card-action">
          <FollowButton
            onClick={this.handleFollowClick}
            following={following}
            size={mq.MS_AND_DOWN ? 'small' : 'medium'}
            width={mq.MS_AND_DOWN ? '90px' : '120px'}
          />
        </div>
      </div>
    );
  }
}

export default CollegeCard;
